import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Law, LawNavItem } from '../models/models';
import { tap } from 'rxjs/operators';

@Injectable()
export class LawService {
    public readonly API_URL = 'api/lawlibrary';
    public _lawDeleted$: Subject<string> = new Subject();
    public _lawCreated$: Subject<Law> = new Subject();
    public _lawUpdated$: Subject<Law> = new Subject();

    get onLawDeleted() { return this._lawDeleted$.asObservable(); }
    get onLawUpdated() { return this._lawUpdated$.asObservable(); }
    get onLawCreated() { return this._lawCreated$.asObservable(); }

    constructor(
        public _httpClient: HttpClient
    ) { }

    getLawNavItems(): Observable<LawNavItem[]> {
        return this._httpClient.get<LawNavItem[]>(`${this.API_URL}/keys`);
    }

    createLaw(name: string, html: string, ORC:string): Observable<Law> {
        return this._httpClient.post<Law>(this.API_URL, {
            name: name,
            data: html,
            ORC: ORC
        }).pipe(tap((result) => {
            this._lawCreated$.next(result);
        }));
    }

    deleteLaw(id: string): Observable<void> {
        return this._httpClient.delete<void>(`${this.API_URL}`, {
            params: {
                id: id
            }
        }).pipe(tap(() => {
            this._lawDeleted$.next(id);
        }));
    }

    updateLaw(law: Law): Observable<Law> {
        return this._httpClient.put<Law>(this.API_URL, law).pipe(tap((result) => {
            this._lawUpdated$.next(result);
        }));
    }

    getLaw(id: string): Observable<Law> {
        return this._httpClient.get<Law>(`${this.API_URL}`, {
            params: {
                id: id
            }
        });
    }
}
